const isIFrame = (card: CanvasCard.Card): card is CanvasCard.IFrameCard =>
  card.content.type === 'iFrame';

export default isIFrame;
